import type {
  EquipmentAssetStatus,
  EquipmentProtocolDirection,
  EquipmentProtocolStatus,
  StaffEquipmentStatus,
  StaffEquipmentType,
} from "@/types/equipment";

export function staffTypeLabel(type: StaffEquipmentType): string {
  if (type === "card") return "Karta";
  if (type === "key") return "Klucz";
  return "Przedmiot";
}

export function staffStatusLabel(status: StaffEquipmentStatus): string {
  switch (status) {
    case "pending_handover":
      return "Oczekuje na odbiór";
    case "assigned":
      return "Przypisany";
    case "pending_return":
      return "Oczekuje na zwrot";
    case "returned":
      return "Zdany";
    default:
      return status;
  }
}

export function assetStatusLabel(status: EquipmentAssetStatus): string {
  switch (status) {
    case "available":
      return "Na stanie";
    case "pending_handover":
      return "Oczekuje na odbiór";
    case "assigned":
      return "U pracownika";
    case "pending_return":
      return "Oczekuje na zwrot";
    case "retired":
      return "Wycofany";
    default:
      return status;
  }
}

export function protocolDirectionLabel(direction: EquipmentProtocolDirection): string {
  return direction === "return" ? "Zwrot" : "Przekazanie";
}

export function protocolStatusLabel(status: EquipmentProtocolStatus): string {
  switch (status) {
    case "pending":
      return "Oczekuje";
    case "accepted":
      return "Zaakceptowany";
    case "rejected":
      return "Odrzucony";
    case "cancelled":
      return "Anulowany";
    default:
      return status;
  }
}

export function truncateText(value: string | null | undefined, max = 80): string {
  const text = value?.trim() ?? "";
  if (!text) return "—";
  if (text.length <= max) return text;
  return `${text.slice(0, max - 1)}…`;
}

export function protocolItemMeta(
  protocol: { kind: string; asset_id: string | null; staff_equipment_id: string | null; condition_notes: string | null },
  assets: { id: string; name: string; serial_number: string | null }[],
  keys: { id: string; name: string }[],
): { name: string; serialNumber: string | null; conditionNotes: string | null } {
  if (protocol.kind === "asset") {
    const asset = assets.find((item) => item.id === protocol.asset_id);
    return {
      name: asset?.name ?? "Narzędzie",
      serialNumber: asset?.serial_number ?? null,
      conditionNotes: protocol.condition_notes,
    };
  }
  const item = keys.find((row) => row.id === protocol.staff_equipment_id);
  return {
    name: item?.name ?? "Przedmiot",
    serialNumber: null,
    conditionNotes: protocol.condition_notes,
  };
}
